// helper to fetch featured project
export const getFeaturedProject = (projects) => {
  return Object.entries(projects)
    .reverse()
    .find(([projID, projObj]) => projObj?.featured);
};
